module.exports = __webpack_public_path__ + "static/media/reservation.1e4066c6.svg";